import React from 'react';
import { VaultAccountPayoutFrequencySetAuditEntry } from '../types';
import RawDisplayValue from '../../RawValueDisplay';
import JsonDisplayValue from '../../JsonDisplayValue';
import logger from '../../../util/logger';

export default function PayoutFrequencySetLog({
  log,
  token,
}: {
  log: VaultAccountPayoutFrequencySetAuditEntry;
  token: string;
}): React.JSX.Element {
  logger(`PayoutFrequencySetLog: ${JSON.stringify(log)}`);

  const sharedProps = {
    token,
    type: 'text' as VgsFieldType,
  };

  return (
    <div className='p-6'>
      {/* created */}
      <div className='md:flex mb-5'>
        <div className='md:w-1/2 px-3 my-2'>
          <RawDisplayValue
            value={log.created.toLocaleString()}
            label='Created'
          />
        </div>
      </div>
      <h2 className='text-xl font-medium mb-4'>Orgs Data</h2>
      <div className='md:flex mb-5'>
        <div className='md:w-1/2 px-3 my-2'>
          <RawDisplayValue value={log.userId} label='User ID' />
        </div>
        <div className='md:w-1/2 px-3 my-2'>
          <RawDisplayValue value={log.orgId} label='Org ID' />
        </div>
      </div>
      <h1 className='text-xl font-medium mb-4'>Stripe Responses</h1>
      <br />
      <JsonDisplayValue
        label='Update Account'
        value={log.updateAccountResponse}
        {...sharedProps}
      />
      <hr />
    </div>
  );
}
